<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
  </cTable>
</template>

<script>
import { getLog, getLogType } from "@/api/user/operation_log";

import cTable from "@/base/common/index";
import { getAllClient } from "@/api/user/client";

export default {
  name: "operationLog",
  components: {
    cTable
  },
  mounted() {
    this.header.searchs.forEach(async item => {
      if (item.key === "type") item.options = (await getLogType()).data.payload;
      if (item.key === "client_id")
        item.options = (await getAllClient()).data.payload.rows;
    });
  },
  data() {
    return {
      methods: {
        list: getLog,
        getLogType
      },
      config: {
        height: 630
      },
      modals: {},
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("clientName");
            },
            options: [],
            config: { label: "account", value: "id" }
          },
          {
            key: "type",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("type");
            },
            options: []
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input"
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              disabled() {
                return !this.selectAll.length;
              },
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            export() {
              this.exportExc();
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          width: 60,
          fixed: "left"
        },
        {
          name: () => this.$t("operate"),
          key: "operate_name",
          width: 130,
          align: "left"
        },
        {
          name: () => this.$t("operation") + this.$t("time"),
          key: "operate_time",
          width: 160
        },
        {
          name: () => this.$t("operation") + this.$t("type"),
          key: "type_txt",
          width: 110,
          align: "left"
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          width: 110,
          align: "left"
        },
        {
          name: () => this.$t("operation") + this.$t("content"),
          key: "operate_content",
          type: "html",
          align: "left"
        }
      ]
    };
  }
};
</script>
